module.exports = __webpack_public_path__ + "static/cameron_b.aa0b7d55.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/reviews/cameron_b.png
// module id = 1714
// module chunks = 35783957827783